import GameService from "../services/game-service";
import { reset, selectGame, setCode, sbcStatusChanged } from "../store/actions/action-creators";
import { incomingMessageTypes, outgoingMessageTypes } from "../constants/message-types";
import GameConfiguration from "../models/game-configuration";
import SbcStatus from "../models/sbc-status";
import SbcRegistrationError from "../models/sbcRegistrationError";
import { SERIAL_NUMBER } from "../App";
import { Store } from "redux";
import { History } from "history";

export class EventHandler {
  private linkToken = "";

  constructor(private store: Store, private history: History, private emit: (message: string, payload?: any) => void) {}

  public handle(event: string, payload?: any): void {
    switch (event) {
      case incomingMessageTypes.gameConfigurationChanged:
        this.onGameConfigurationChanged(payload);
        break;
      case incomingMessageTypes.unlink:
        this.onUnlink();
        break;
      case incomingMessageTypes.linkRequest:
        this.onLinkRequest();
        break;
      case incomingMessageTypes.codeResponse:
        this.onCodeResponse(payload);
        break;
      case incomingMessageTypes.selectGameRequest:
        this.onSelectGameRequest(payload);
        break;
      case incomingMessageTypes.startGame:
        this.history.push("/game");
        this.onStartGame();
        break;
      case incomingMessageTypes.abortGame:
        this.onAbortGame();
        break;
      case incomingMessageTypes.listGamesRequest:
        this.onListGamesRequest();
        break;
      case incomingMessageTypes.throw:
        GameService.throwDetected(payload);
        break;
      case incomingMessageTypes.takeoutStarted:
        GameService.takeoutStarted(payload);
        break;
      case incomingMessageTypes.takeoutFinished:
        GameService.takeoutFinished(payload);
        break;
      case incomingMessageTypes.loadGame:
        this.history.push("/load-game");
        break;
      case incomingMessageTypes.playerListChanged:
        GameService.playerListChanged(payload);
        break;
      case incomingMessageTypes.sbcStatusChanged:
        this.onSbcStatusChanged(payload);
        break;
      case incomingMessageTypes.sbcRegistrationError:
        this.onSbcRegistrationError(payload);
        break;
      case incomingMessageTypes.reconnect:
        this.onReconnect();
        break;
      case incomingMessageTypes.linkResponse:
        this.onLinkResponse(payload);
        break;
    }
  }

  private onGameConfigurationChanged(values: GameConfiguration): void {
    GameService.updateGameConfiguration(values);
  }

  private onUnlink(): void {
    GameService.reset();
    this.store.dispatch<any>(reset());
    this.history.push(`/?serialNumber=${sessionStorage.getItem(SERIAL_NUMBER)}`);
  }

  private onLinkRequest(): void {
    this.history.push("/game-list");
  }

  private onCodeResponse({ code, token }: { code: string; token: string }): void {
    this.linkToken = token;
    this.store.dispatch(setCode(code));
  }

  private onSelectGameRequest({ gameId }: { gameId: string }): void {
    this.store.dispatch<any>(selectGame(gameId));
  }

  private onStartGame(): void {
    GameService.startGame();
  }

  private onAbortGame(): void {
    GameService.reset();
    this.history.push("/game-list");
  }

  private onListGamesRequest(): void {
    const { gameList } = this.store.getState();
    this.emit(outgoingMessageTypes.listGamesResponse, gameList);
  }

  private onSbcStatusChanged(sbcStatus: SbcStatus): void {
    this.store.dispatch<any>(sbcStatusChanged(sbcStatus));
    if (sbcStatus.status === "offline") {
      GameService.reset();
      this.store.dispatch<any>(reset());
      this.emit(outgoingMessageTypes.reload);
      this.history.push(`/?serialNumber=${sessionStorage.getItem(SERIAL_NUMBER)}`);
    }
  }

  private onSbcRegistrationError(sbcRegistrationError: SbcRegistrationError): void {
    if (sbcRegistrationError.reason === "in_use") {
      this.store.dispatch<any>(sbcStatusChanged({ status: sbcRegistrationError.reason }));
    }
  }

  private onLinkResponse({ success, linkToken, msg }: { success: boolean; linkToken: string; msg: string }): void {
    if (success) {
      this.linkToken = linkToken;
    } else {
      this.linkToken = "";
      this.onUnlink();
    }
  }

  private onReconnect(): void {
    if (this.linkToken !== "") {
      const code: string = this.linkToken;
      this.emit(outgoingMessageTypes.linkRequestWithToken, { code });
    }
  }
}
